import Button, {ButtonProps} from 'antd/es/button';
import React, {FC} from 'react';
import {Link} from 'react-router-dom';

export interface ILinkButtonProps {
    title: string;
    link?: string;
    type?: ButtonProps['type'];
}
export const LinkButton: FC<ILinkButtonProps> = ({link = '', title, type = 'primary'}: ILinkButtonProps) => (
    <Link to={link}>
        <Button type={type}>{title}</Button>
    </Link>
);

const linkButtonPropsPresets : Record<string, ILinkButtonProps> = {
    PASS_TO_SECTION: {type: 'default', title: 'Перейти в раздел'},
    RISKS_REGISTRY: {type: 'default', title: 'Общий реестр рисков'},
    KP_REGISTRY: {type: 'default', title: 'Общий реестр КП'},
    RISKS_LIBRARY: {type: 'default', title: 'Библиотека рисков'},
    KP_LIBRARY: {type: 'default', title: 'Библиотека контрольных процедур'},
} as const;
type TLinkButtonsPropsPreset = keyof typeof linkButtonPropsPresets;

interface ICreateLinkButtonWithPresetArgs {
    link: string;
    preset: TLinkButtonsPropsPreset;
}

export const createLinkButtonPropsWithPreset = ({link, preset}: ICreateLinkButtonWithPresetArgs) => (
    {
        link,
        ...linkButtonPropsPresets[preset],
    }
);
